module.exports = __webpack_public_path__ + "images/icons_v2/key-baddc278.svg";